<template>
  <div>
    <el-dialog
      title="แก้ไข Order"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-escape="false"
      :close-on-click-modal="false"
      @closed="onHidden"
      :before-close="onHidden"
      custom-class="loadingDivAddrEdit"
      center
    >
      <el-form label-position="left" label-width="150px">
        <el-autocomplete
            v-model="state4"
            :fetch-suggestions="querySearchAsync"
            placeholder="ค้นหา"
            :debounce="500"
            :trigger-on-focus="false"
            highlight-first-item
            clearable
            @select="handleSelect($event)"
            style="width: 100%;margin-bottom:20px;"
        >
            <template slot-scope="{ item }">
                <div>{{ item.detail }} / {{ item.provinceName }} / {{ item.districtName }} / {{ item.subDistrictName }}</div>
            </template>
        </el-autocomplete>
        <el-form-item label="ที่อยู่" label-width="100px">
            <el-input
                v-model="detail.addr"
                :autosize="{ minRows: 3, maxRows: 6}"
                type="textarea"
                placeholder="ที่อยู่"
                label-width="200px"
            ></el-input>
          <!-- <el-input v-model="detail.addr"></el-input> -->
        </el-form-item>
        <address-zipcode-system :address.sync="detail" :dialogShow="dialogShow" :invalidAddress.sync="invalidAddress" />
        <!-- <el-form-item label="จังหวัด">
          <el-input v-model="detail.province"></el-input>
        </el-form-item>
        <el-form-item label="อำเภอ">
          <el-input v-model="detail.district"></el-input>
        </el-form-item>
        <el-form-item label="ตำบล">
          <el-input v-model="detail.subdistrict"></el-input>
        </el-form-item>
        <el-form-item label="zipcode">
          <el-input v-model="detail.zipcode"></el-input>
        </el-form-item> -->
        <el-form-item label="หมายเหตุ" label-width="100px">
            <el-input
                v-model="detail.note"
                :autosize="{ minRows: 3, maxRows: 6}"
                type="textarea"
                placeholder="หมายเหตุ"
                label-width="200px"
            ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">ยกเลิก</el-button>
        <el-button :disabled="invalidAddress.status" type="primary" @click="submitDataNewFlow">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import addressZipcodeSystem from '@/components/address/addressZipcodeSystem.vue'
export default {
    name: 'EditAddrCustomer',
    components: {
        'address-zipcode-system': addressZipcodeSystem
    },
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        addrDetail: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            dialogVisible: false,
            loading: false,
            state4: '',
            timeout: null,
            detail: {},
            searchAddressTable: new Array(0),
            addressInfo: [],
            isSelectAddress: false,
            invalidAddress: {
                status: false,
                dialogShow: false
            }
        }
    },
    watch: {
        dialogShow: {
            immediate: true,
            handler (status) {
                this.invalidAddress.dialogShow = status
                this.dialogVisible = status
            }
        },
        addrDetail (val) {
            if (val) {
                this.detail = { ...val }
            }
        }
    },
    methods: {
        onHidden (done) {
            this.loading = false
            this.runningNumberForm = this.payment_detail_id_form
            this.$emit('closeModalEditAddr')
            if (done !== undefined) {
                done()
            }
        },
        async fetchAddressInfoFromDatabase (param) {
            try {
                let resSearchAddressInfo = await fgApi.order.searchZipcode(param)
                if (resSearchAddressInfo.success) {
                    this.addressInfo = resSearchAddressInfo.data.zipcode
                } else {
                    console.error('Api sent data failed!!')
                }
            } catch (error) {
                console.error(error)
            }
        },
        querySearchAsync (queryString, cb) {
            if (queryString !== '') {
                let param = {
                    search: queryString
                }
                clearTimeout(this.timeout)
                this.timeout = setTimeout(async () => {
                    await this.fetchAddressInfoFromDatabase(param)
                    cb(this.addressInfo)
                }, 500)
            } else {
                return true
            }
        },
        handleSelect (item) {
            this.detail.province = item.provinceName
            this.detail.district = item.districtName
            this.detail.subdistrict = item.subDistrictName
            this.detail.zipcode = item.detail
        },
        async submitDataNewFlow () {
            let loadingAddUser = this.$loading({
                target: '.loadingDivAddrEdit',
                text: 'กำลังบันทึก...'
            })
            if (this.detail.orderDetail.courierId === 10) { // Bee เช็คที่อยู่
                // let result = zipcodeBee.findIndex(e => {
                //     return e.province === this.detail.province && e.zipcode === this.detail.zipcode
                // })
                try {
                    let resCheckZIpcode = await fgApi.order.checkZipcode(`courier_id=${this.detail.orderDetail.courierId}&sub_district=${this.detail.subdistrict}&zipcode=${this.detail.zipcode}&is_mobile=false`)
                    if (!resCheckZIpcode.success) {
                        loadingAddUser.close()
                        this.$alert('ออเดอร์นี้จัดส่งโดย BEE: รหัสไปรษณีย์ไม่ได้อยู่ในขอบเขตการให้บริการ', 'แจ้งเตือน', {
                            confirmButtonText: 'ปิด',
                            type: 'warning'
                        })
                        return
                    }
                } catch (error) {
                    this.$message({
                        message: error,
                        type: 'error'
                    })
                }
            }

            let dataCheck = {
                shipping_address: this.detail.orderDetail.shippingAddress,
                shipping_sub_district: this.detail.orderDetail.shippingSubDistrict,
                shipping_district: this.detail.orderDetail.shippingDistrict,
                shipping_province: this.detail.orderDetail.shippingProvince,
                shipping_zipcode: this.detail.orderDetail.shippingZipcode
            }
            let paramCheck = {
                shipping_address: this.detail.addr,
                shipping_sub_district: this.detail.subdistrict,
                shipping_district: this.detail.district,
                shipping_province: this.detail.province,
                shipping_zipcode: this.detail.zipcode
            }
            let param = {
                ...paramCheck,
                courier_id: this.detail.orderDetail.courierId,
                adminEmail: this.$store.get('user/objUser').email,
                order_number: this.detail.order_number,
                note: this.detail.note ? this.detail.note : ''
            }
            if (this.detail.orderDetail.courierId === 4) {
                if (JSON.stringify(paramCheck) !== JSON.stringify(dataCheck)) {
                    param['is_reprint'] = true
                    param['is_print'] = false
                }
            } else {
                param['is_reprint'] = false
                param['is_print'] = false
            }
            try {
                let res = await fgApi.order.updateOrderAddress(param)
                if (res.success) {
                    if (this.detail.orderDetail.status === 1 || this.detail.orderDetail.status === 2 || this.detail.orderDetail.status === 3) {
                        if (this.detail.orderDetail.courierId === 4) {
                            let paramCreateShipment = {
                                order_numbers: [String(this.detail.orderDetail.orderNumber)],
                                shop_id: this.detail.orderDetail.shopId,
                                status: this.detail.orderDetail.status,
                                adminEmail: this.$store.get('user/objUser').email
                            }
                            let resCreateShipment = await fgApi.order.createShipment(paramCreateShipment)
                            try {
                                await fgApi.order.updateDeliveryCost(paramCreateShipment)
                            } catch (error) {
                                console.log(error)
                            }
                            console.log(resCreateShipment)
                            this.$message({
                                message: 'success',
                                type: 'success'
                            })
                            this.dialogVisible = false
                            this.$emit('closeRefresh', this.addrDetail.orderDetail.orderId)
                        } else {
                            this.$message({
                                message: 'success',
                                type: 'success'
                            })
                            this.dialogVisible = false
                            this.$emit('closeRefresh', this.addrDetail.orderDetail.orderId)
                        }
                    } else {
                        this.$message({
                            message: 'success',
                            type: 'success'
                        })
                        this.dialogVisible = false
                        this.$emit('closeRefresh', this.addrDetail.orderDetail.orderId)
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            } catch (error) {
                this.$message({
                    message: error,
                    type: 'error'
                })
            }
            loadingAddUser.close()
        }
    }
}
</script>

<style lang="scss">
</style>
